export function preciseRound(value, decPlaces) {
  var val = value * Math.pow(10, decPlaces);
  var fraction = Math.round((val - parseInt(val)) * 10) / 10;

  //this line is for consistency with .NET Decimal.Round behavior
  // -342.055 => -342.06
  if (fraction == -0.5) fraction = -0.6;

  val = Math.round(parseInt(val) + fraction) / Math.pow(10, decPlaces);
  return val;
}


export function roundToNearestHalf(number) {
  // Multiply by 2 to handle halves
  var rounded = Math.round(number * 2) / 2;
  return rounded;
}


export function toStringTwoDecimals(value) {
  var sum = preciseRound(value, 2);
  return sum.toFixed(2);
}
export function displayMoney(amount, vat) {
  let price = 0;
  if (!isNaN(amount)) {
    if (isNaN(vat) || vat === 0) {
      price = amount;
    } else {
      price = (amount + amount * (vat / 100)).toFixed(4);
    }
  }
  return preciseRound(price, 2);
}

export function removeZerosFromNumber(num) {
  if (num % 1 != 0) {
    let numString = num.toString();
    let newNumString = '';
    for (let index = numString.length - 1; index >= 0; index--) {
      let v = numString.charAt(index);
      if (v !== '0' || newNumString.includes('.')) newNumString = v + newNumString;
    }

    newNumString = parseFloat(newNumString);
    return newNumString;
  }
  return num;
}
